module.exports = __webpack_public_path__ + "media/images/ui__textArrowDownLight-c3b6f3f8bbaf8539da5b0ae4b482c233.png";